<template><div><h1 id="frage-nicht-gefunden" tabindex="-1"><a class="header-anchor" href="#frage-nicht-gefunden"><span>Frage nicht gefunden?</span></a></h1>
<p>Hast du nach einer Antwort auf eine Frage gesucht, diese aber nicht gefunden?</p>
<p>Lass es uns wissen und schick uns eine Email an <a href="mailto:hallo@funtrade.ch" target="_blank" rel="noopener noreferrer">hallo@funtrade.ch</a> 👌🏻</p>
</div></template>


